module.exports = __webpack_public_path__ + "static/media/oldteam.9ddc0421.jpg";